<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2l"><a id="page_4"></a><a id="ch03">AND THEN</a></h2><a id="ch03">
<p class="noindent1">Tuesday, August 1, 2006, 7:25 a.m.</p>
<p class="noindent">“I can’t breathe,” she whispers.</p>
<p class="indent">His hot fingers lace her ribs, sear through her skin to her frozen lungs. He holds her. Kisses her. Breathes for her. Through her.</p>
<p class="indent">Makes her forget.</p>
<p class="indenta">Afterward, he says, “We’re going. Right now. Come.”</p>
<p class="indenta">She does it.</p>
</a><p class="indenta"><a id="ch03">On the three-hour drive, she looks through eyelashes at her blurred fingers, curled in her lap. Pretends to be </a><a id="page_5">asleep. Not sure why. Just soaking in the quiet. And knowing, deep down.</a></p><a id="page_5">
<p class="indent">Knowing that he,</p>
<p class="indent">and this,</p>
<p class="indent">are not answers to her problems.</p>
<p class="indenta">She’s beginning to realize what is.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch03.vue?e65424d4